module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brutto text-dark",
    class: {
      'brutto--kindergarten': _vm.isKindergarten
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.setIsNormModal
    }
  }, [_vm._v("Normberegning")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false,
      "placeInTop": true
    }
  }, [_c('div', {
    staticClass: "brutto-container brutto-container-denmark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h2', [_vm._v("Normberegning")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [_c('div', {
    staticClass: "brutto-container__body__left"
  }, [_c('div', {
    staticClass: "d-tabs__header"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditWorkHours),
      expression: "isEditWorkHours"
    }],
    staticClass: "d-tabs"
  }, [_c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.getIsActiveTab(0)
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab(0)
      }
    }
  }, [_vm._v("\n                Bruttotid\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.getIsActiveTab(1)
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab(1)
      }
    }
  }, [_vm._v("\n                Nettotid\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__header__right",
    class: {
      'd-tabs__header__right--alone': !_vm.isEditWorkHours
    }
  }, [_c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": function($event) {
        _vm.isEditWorkHours = !_vm.isEditWorkHours
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indsæt arbejdstid")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isEditWorkHours
    }
  })], 1)])]), _vm._v(" "), (_vm.isEditWorkHours) ? _c('div', {
    staticClass: "d-tabs__content"
  }, [_c('AssignHoursNormList', {
    attrs: {
      "standardNettoHours": _vm.originalNettoTime,
      "standardHolidayHours": _vm.originalHolidayHours,
      "standardLocalAgreementHours": _vm.originalLocalAgreementHours,
      "isNetto": _vm.activeTab === 1,
      "isKindergarten": _vm.isKindergarten,
      "schoolYear": _vm.activeSchoolYear,
      "theEditUserNorm": _vm.theEditUserNorm
    },
    on: {
      "onEditBrutto": function($event) {
        return _vm.setActiveTab(0)
      },
      "onEditNetto": function($event) {
        return _vm.setActiveTab(1)
      },
      "updated": _vm.setItemsToSave,
      "changedSum": _vm.setNettoTime,
      "onEditedStandardWorkingHours": function($event) {
        return _vm.setIsShowNewNettoModal($event)
      },
      "onOpenHolidaysSettings": _vm.openHolidaysSettingsModal,
      "onOpenLocalAgreementSettings": _vm.openLocalAgreementSettingsModal,
      "changedEmploymentRate": _vm.onChangedEmploymentRate
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten && (!_vm.isPoolsDeactivated || _vm.isAssignedPoolFromNormWhenPoolsDeactivated)) ? _c('div', {
    staticClass: "more-norms"
  }, [(_vm.isEditWorkHours && !_vm.isPoolsDeactivated) ? _c('div', {
    staticClass: "rest-calculation"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Rest / Ikke fordelt på puljer")]), _vm._v("\n              " + _vm._s(_vm.restCalculation) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "brutto__items"
  }, _vm._l((_vm.displayedNormPoolItems), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "brutto__items__item__container"
    }, [_c('div', {
      staticClass: "label-with-toggle",
      on: {
        "click": function($event) {
          return _vm.toggleItemById(item.id)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Indsæt " + _vm._s(_vm.getItemName(item)))]), _vm._v(" "), _c('app-toggle', {
      attrs: {
        "allowChanges": false,
        "propOn": _vm.isItemToggledById(item.id)
      }
    })], 1), _vm._v(" "), (_vm.isItemToggledById(item.id)) ? _c('div', {
      staticClass: "brutto__items__item"
    }, [_c('span', {
      staticClass: "norm-title"
    }, [_vm._v("\n                    " + _vm._s(_vm.getItemName(item)) + "\n                    "), (_vm.prepFactor && item.id === 'assigned_preparation_hours') ? _c('span', {
      staticClass: "norm-title__sub"
    }, [(_vm.substitutePoolHoursForPrep !== null) ? [_vm._v("\n                        " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * (" + _vm._s(_vm.hoursForTeaching) + " UV + " + _vm._s(_vm.substitutePoolHoursForPrep) + " vikar)\n                      ")] : [_vm._v("\n                        " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * " + _vm._s(_vm.hoursForTeaching) + " UV\n                      ")]], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return _vm.isShowPrepFactorTooltip(item); }
        }),
        expression: "{\n                    arrow: true,\n                    animateFill: false,\n                    animation : 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window',\n                    onShow: () => isShowPrepFactorTooltip(item)\n                  }"
      }],
      staticClass: "d-input-group__input",
      attrs: {
        "content": "Forberedelse opdateres automatisk ift. hvad der er tildelt i \"Undervisning\""
      }
    }, [(_vm.isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && _vm.prepFactor)) ? _c('div', {
      staticClass: "employment-rate-calculator"
    }, [_vm._v("\n                      (" + _vm._s(_vm.formatEmploymentRateText(item)) + ")\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.unit ? item.unit : 'timer'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.hours),
        expression: "item.hours"
      }],
      attrs: {
        "disabled": _vm.prepFactor && item.id === 'assigned_preparation_hours',
        "type": "number"
      },
      domProps: {
        "value": (item.hours)
      },
      on: {
        "change": function($event) {
          return _vm.onUpdatingHours(item, $event.target.value)
        },
        "focus": function($event) {
          return $event.target.select()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "hours", $event.target.value)
        }
      }
    })])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brutto__items__item__container brutto__items__item__container__notefield",
    class: {
      'brutto__items__item__container__notefield--alone': _vm.isPoolsDeactivated
    }
  }, [_c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": _vm.setIsShowAgreement
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indsæt en note til de valgte personer")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isShowAgreement
    }
  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
    attrs: {
      "isKeepOpen": true,
      "is-open": true,
      "isInTestOfSaveButton": false
    },
    on: {
      "changed": _vm.updateAgreements
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_c('svg', {
    staticClass: "icon-archive tw-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
    }
  })]), _vm._v("\n              Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "brutto__users",
    class: {
      'brutto__users--wide': _vm.showAllFields
    }
  }, [_c('div', {
    staticClass: "brutto__users__header brutto__users__header__filters"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "users": _vm.usersSortedOnNameWithTags,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "clear": function($event) {
        _vm.appliedFilters = []
      },
      "select": _vm.toggleFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": function($event) {
        _vm.showAllFields = !_vm.showAllFields
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vis alle felter")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.showAllFields
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "norm-select-users__header"
  }, [_c('div', {
    staticClass: "text-link",
    on: {
      "click": _vm.toggleAllDisplayed
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isAllDisplayedSelected ? 'Fravælg alle' : 'Vælg alle') + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(" Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.usersSortedOnName.length))])]), _vm._v(" "), _c('div', {
    staticClass: "brutto__users__list"
  }, [(_vm.isLoadingAllUsers || _vm.isLoadingUserYears) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "is-clickable",
    on: {
      "click": function($event) {
        return _vm.setNormSort('name')
      }
    }
  }, [_vm._v("\n                  Navn\n                  "), (_vm.normSort.key === 'name') ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.coreColumns), function(col) {
    return _c('th', {
      key: 'h-core-' + col,
      staticClass: "is-clickable",
      on: {
        "click": function($event) {
          return _vm.setNormSort(col)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.shortNormTitle(col)) + "\n                  "), (_vm.normSort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.extraColumns), function(col) {
    return (_vm.showAllFields) ? _c('th', {
      key: 'h-extra-' + col,
      staticClass: "is-clickable",
      on: {
        "click": function($event) {
          return _vm.setNormSort(col)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.shortNormTitle(col)) + "\n                  "), (_vm.normSort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.normSort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.normDisplayedRows), function(row) {
    return _c('tr', {
      key: row.id,
      class: {
        'is-selected': _vm.getIsUserSelected(row)
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(row)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "do-checkbox",
      class: {
        'do-checkbox--selected': _vm.getIsUserSelected(row)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.coreColumns), function(col) {
      return _c('td', {
        key: 'c-core-' + row.id + '-' + col
      }, [_vm._v("\n                  " + _vm._s(row.values[col]) + "\n                ")])
    }), _vm._v(" "), _vm._l((_vm.extraColumns), function(col) {
      return (_vm.showAllFields) ? _c('td', {
        key: 'c-extra-' + row.id + '-' + col
      }, [_vm._v("\n                  " + _vm._s(row.values[col]) + "\n                ")]) : _vm._e()
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "icon__bg-circle d-edit-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editUserNorm(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })])])], 2)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        onShow: function () { return _vm.selectedUsers.length < 1; }
      }),
      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
    }],
    staticClass: "bttn bttn-primary",
    class: [{
      'bttn-primary--disabled': _vm.selectedUsers.length < 1
    }, {
      'bttn--loading': _vm.isSaving
    }],
    attrs: {
      "content": "Der skal vælges minimum en bruger"
    },
    on: {
      "click": function($event) {
        return _vm.setIsWarningActive(true)
      }
    }
  }, [_vm._v("Gem\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
    staticStyle: {
      "z-index": "999999999"
    },
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Du er ved at tildele arbejdstid på " + _vm._s(_vm.nettoTime) + " til de valgte brugere. Hvis der i forvejen er tildelt en\n          arbejdstid vil dette blive erstattet.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary bttn-primary--small",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Gem\n          og erstat\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.theNewNettoValue) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowNewNettoModal(null)
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v("Vil du gemme " + _vm._s(_vm.theNewNettoValue) + " som den nye standard netto tid på skolen, så du ikke skal\n      taste det næste gang?")]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setIsShowNewNettoModal(null)
      }
    }
  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveNewNettoTime
    }
  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isShowHolidaysSettingsModal) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": _vm.closeHolidaysSettingsModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "item",
      "id": "holidays-settings"
    },
    slot: "item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.holidaysSettingsReadOnly ? 'Helligdage i perioden' : 'Standard for søgnehelligdage'))]), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('p', [_vm._v("Indtast den standard for søgnehelligdage som skal bruges i skoleåret\n        "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.activeSchoolYearName))]), _vm._v(". Værdien gælder ved fuld tid og bliver automatisk skaleret\n        efter beskæftigelsesgrad.")]) : _c('p', [_vm._v("Her vises helligdagene i den valgte periode. Skolens standard for søgnehelligdage kan kun redigeres,\n        når perioden er hele skoleåret.")]), _vm._v(" "), (_vm.holidaysSettingsList.length) ? _c('div', {
    staticClass: "holidays-settings__list"
  }, [_c('div', {
    staticClass: "holidays-settings__list__header"
  }, [_c('span', [_vm._v("Helligdage i perioden")])]), _vm._v(" "), _c('ul', _vm._l((_vm.holidaysSettingsList), function(holiday) {
    return _c('li', {
      key: holiday.date,
      class: {
        'is-standard': holiday.isStandard,
        'is-weekend': !holiday.isStandard
      }
    }, [(holiday.isStandard) ? _c('span', {
      staticClass: "holidays-settings__number"
    }, [_vm._v(_vm._s(holiday.standardIndex))]) : _c('span', {
      staticClass: "holidays-settings__number holidays-settings__number--empty"
    }, [_vm._v("—")]), _vm._v(" "), (holiday.name) ? _c('span', {
      staticClass: "holidays-settings__name"
    }, [_vm._v(_vm._s(holiday.name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "holidays-settings__date"
    }, [_vm._v(_vm._s(holiday.formatted))]), _vm._v(" "), (!holiday.isStandard) ? _c('span', {
      staticClass: "holidays-settings__tag"
    }, [_vm._v("weekend")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "holidays-settings__list__sum"
  }, [_vm._v("\n          " + _vm._s(_vm.holidaysSettingsStandardCount) + " standard dage × 7,4 timer =\n          "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.holidaysSettingsCalculatedValue) + " timer")])])]) : _vm._e(), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('div', {
    staticClass: "holidays-settings__input"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Timer ved fuld tid")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaysSettingsValue),
      expression: "holidaysSettingsValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.holidaysSettingsValue)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holidaysSettingsValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("timer")])])]) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('div', {
    staticClass: "holidays-settings__buttons"
  }, [(!_vm.holidaysSettingsReadOnly && _vm.originalHolidayHours > 0) ? _c('button', {
    staticClass: "do-bttn bttn--danger",
    on: {
      "click": _vm.deleteHolidaysSettings
    }
  }, [_vm._v("\n        Nulstil\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "holidays-settings__buttons__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeHolidaysSettingsModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.holidaysSettingsReadOnly ? 'Luk' : 'Annullér') + "\n      ")]), _vm._v(" "), (!_vm.holidaysSettingsReadOnly) ? _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveHolidaysSettings
    }
  }, [_vm._v("\n        " + _vm._s(_vm.originalHolidayHours > 0 ? 'Opdater' : 'Gem') + "\n      ")]) : _vm._e()])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isShowLocalAgreementSettingsModal) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": _vm.closeLocalAgreementSettingsModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "item",
      "id": "holidays-settings"
    },
    slot: "item"
  }, [_c('h3', [_vm._v("Standard for tilpasning til lokalaftale")]), _vm._v(" "), _c('p', [_vm._v("Indtast den standardværdi for tilpasning til lokalaftale, som skal bruges. Værdien gælder ved fuld tid og\n        bliver automatisk skaleret efter beskæftigelsesgrad.")]), _vm._v(" "), _c('div', {
    staticClass: "holidays-settings__input"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Timer ved fuld tid")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localAgreementSettingsValue),
      expression: "localAgreementSettingsValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localAgreementSettingsValue)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localAgreementSettingsValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("timer")])])])]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('div', {
    staticClass: "holidays-settings__buttons"
  }, [(_vm.originalLocalAgreementHours > 0) ? _c('button', {
    staticClass: "do-bttn bttn--danger",
    on: {
      "click": _vm.deleteLocalAgreementSettings
    }
  }, [_vm._v("\n          Nulstil\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "holidays-settings__buttons__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeLocalAgreementSettingsModal
    }
  }, [_vm._v("\n            Annullér\n          ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveLocalAgreementSettings
    }
  }, [_vm._v("\n            " + _vm._s(_vm.originalLocalAgreementHours > 0 ? 'Opdater' : 'Gem') + "\n          ")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.theNewStandardHoursForPool) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.setTheNewStandardHoursForPool(null)
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v("\n      Vil du gemme "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.hours) + " timer")]), _vm._v(" som den nye standard for\n      "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.name) + "-puljen")]), _vm._v(", så du ikke behøver at indtaste det næste\n      gang?\n    ")]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setTheNewStandardHoursForPool(null)
      }
    }
  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveNewStandardHours
    }
  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isModalAutoCalculateOpen) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        _vm.isModalAutoCalculateOpen = false
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h3', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("Skal puljer automatisk opdateres?")]), _vm._v(" "), _c('ul', _vm._l((_vm.checkedItemsToUpdate), function(checkedItem) {
    return _c('li', {
      key: checkedItem.id
    }, [_c('b', [_vm._v(_vm._s(checkedItem.name) + ":")]), _vm._v(" " + _vm._s(_vm.formatEmploymentRateText(checkedItem, true)) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isModalAutoCalculateOpen = false
      }
    }
  }, [_vm._v("\n        Ikke opdatér\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.updateActivePoolsFromEmploymentRate
    }
  }, [_vm._v("\n        Opdatér puljer\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.theEditUser) ? _c('AssignHoursNormEditIUserModal', {
    attrs: {
      "user": _vm.theEditUser,
      "schoolYear": _vm.activeSchoolYear,
      "schoolId": _vm.schoolId
    },
    on: {
      "updated": _vm.onUpdatedUserNorm,
      "close": function($event) {
        return _vm.setTheEditUser(null)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4d65834!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursNorm.vue
// module id = 2120
// module chunks = 1